<template>
  <div>
    <b-modal
      id="admin-edit-modal"
      ref="editAdminModalRef"
      title="Edit Admin Role"
      ok-title="Save"
      no-close-on-backdrop
      @ok="handleOK"
    >
      <b-overlay
        :show="showLoading"
        rounded="sm"
        no-fade
      >
        <!-- Form -->
        <b-form
          v-if="adminData"
          class="p-2"
          @submit.prevent="onSave"
        >
          <b-form-group
            label="Status"
            label-for="edit-status"
          >
            <v-select
              v-model="adminData.role"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="roles.map(role => role.name)"
              :clearable="false"
            />
          </b-form-group>
          <b-form-group
            label="Country"
            label-for="edit-country"
          >
            <v-select
              v-model="adminData.countries"
              :options="countries"
              :reduce="v => v.code"
              multiple
              :clearable="false"
            />
          </b-form-group>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, VBModal, BForm, BOverlay, BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import roleStoreModule from '@/views/users/roles/roleStoreModule'
import useRolesList from '@/views/users/roles/userRolesList'
import countries from './countries'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BOverlay,

    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    editAdminData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    // Register Role Module
    const ROLE_APP_STORE_MODULE_NAME = 'roles'

    // Register module
    if (!store.hasModule(ROLE_APP_STORE_MODULE_NAME)) {
      store.registerModule(ROLE_APP_STORE_MODULE_NAME, roleStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLE_APP_STORE_MODULE_NAME)
    })
    const adminData = ref(null)
    const showLoading = ref(false)
    const editAdminModalRef = ref(null)

    const {
      roles,
      fetchRoles,
    } = useRolesList()

    fetchRoles()

    const onSave = async () => {
      showLoading.value = true
      await store.dispatch('admins/putAdmin', {
        ...adminData.value,
      })
      emit('refetch-data')
      showLoading.value = false
    }

    const handleOK = async bvModalEvt => {
      bvModalEvt.preventDefault()
      await onSave()
      editAdminModalRef.value.hide()
    }
    watch(() => props.editAdminData, admin => {
      adminData.value = JSON.parse(JSON.stringify(admin))
    })
    return {
      roles,
      adminData,
      showLoading,
      editAdminModalRef,
      onSave,
      countries,
      handleOK,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
